import React from "react";
import * as Styled from "./styles";
import { ASSETS } from "../../utils/config";
import { TextView } from "components";
import Icon from "assets/images/settings/insurance.svg";
import styled from "styled-components";
import { colors } from "../../utils";

const Item = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
`;

const Separator = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${colors.lightBorder};
`;
export default function Security() {
  return (
    <Styled.CenterWrapper>
      <Styled.ContentHeader>
        <Styled.HeaderIcon src={Icon} />
        <TextView variant="title">Legal</TextView>
      </Styled.ContentHeader>
      <Styled.Content>
        <Item>
          <TextView style={{ marginBottom: 5 }} variant="subtitle">
            Terms of Service
          </TextView>
          <TextView>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat. Duis aute irure dolor in
            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
            pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
            culpa qui officia deserunt mollit anim id est laborum.
          </TextView>
        </Item>
        <Separator />
        <Item>
          <TextView style={{ marginBottom: 5 }} variant="subtitle">
            Privacy Policy
          </TextView>
          <TextView>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat. Duis aute irure dolor in
            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
            pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
            culpa qui officia deserunt mollit anim id est laborum.
          </TextView>
        </Item>
        <Separator />
        <Item>
          <TextView style={{ marginBottom: 5 }} variant="subtitle">
            Content Policy
          </TextView>
          <TextView>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat. Duis aute irure dolor in
            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
            pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
            culpa qui officia deserunt mollit anim id est laborum.
          </TextView>
        </Item>
      </Styled.Content>
    </Styled.CenterWrapper>
  );
}
